export default __webpack_public_path__ + "static/icon-30-2-39ff201649bae747b5b51c3f9556f6a4.png";